import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Container } from '../styled-components/Layout';
import { Button } from '../styled-components/';
import localize from '../util/localizeUtils';

import DraggablePopup from './DraggablePopup';

const PromptContainer = styled(Container)`
  margin: 0.5rem;
`;

const ButtonContainer = styled.div`
  margin-top: 0.5rem;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
`;

const DialogButton = styled(Button)`
  margin-left: 0.5rem;
`;

const ContentContainer = styled.div`
  width: 100%;
  height: auto;
`;

class ConfirmDialog extends Component {
  handleClick = (e, confirm) => {
    this.props.onConfirm(confirm);
  };

  render() {
    const { visible, onClose, content, confirmButtonText, title } = this.props;
    return (
      <DraggablePopup
        title={title}
        closeDialog={this.props.onClose}
        defaultPosition={{ x: 50, y: 50 }}
        axis="none"
        height={7 * parseFloat(getComputedStyle(document.documentElement).fontSize)}
        z-index={100}
        handle=".handle"
        visible={visible}
      >
        <PromptContainer>
          <ContentContainer>
            <span>{content}</span>
          </ContentContainer>
          <ButtonContainer>
            <DialogButton onClick={this.handleClick}>{confirmButtonText}</DialogButton>
            <DialogButton onClick={onClose}>{localize('cancelButton')}</DialogButton>
          </ButtonContainer>
        </PromptContainer>
      </DraggablePopup>
    );
  }
}

ConfirmDialog.defaultProps = {
  visible: false,
  title: localize('confirmTitle'),
  content: '',
  confirmButtonText: localize('okButton')
};

ConfirmDialog.propTypes = {
  title: PropTypes.string,
  visible: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  content: PropTypes.string,
  confirmButtonText: PropTypes.string
};

export default ConfirmDialog;



// WEBPACK FOOTER //
// ./app/components/ConfirmDialog.js